// extracted by mini-css-extract-plugin
export default {"withMargins":"src-views-analytics-components-AnalyticsTopsnapTimeSpentGraph-AnalyticsTopsnapTimeSpentGraph__withMargins--vo24W"};